<template>
  <div @click="handleClick">
    <slot :noCoupon="!couponData.length" :selectedCoupon="localValue" />
    <van-popup
      v-model="visible"
      :round="true"
      position="bottom"
      :safe-area-inset-bottom="true"
      get-container="body"
      @click.native.stop
    >
      <div :class="_.page">
        <div :class="_.hd">
          <input
            v-model="code"
            v-fix-keyboard
            placeholder="请输入优惠码"
            :class="_.input"
          />
          <div :class="_.button" @click="handleExchangeClick">兑换</div>
        </div>
        <div :class="_.bd">
          <!-- <van-tabs v-model="typeIndex" :class="_.tabs">
            <van-tab title="可用" />
            <van-tab title="不可用" />
          </van-tabs> -->
          <van-radio-group v-model="localRadio">
            <div :class="_.list">
              <x-waterfall
                ref="list"
                :auto-fit="true"
                :no-complete-tips="true"
                empty-text="暂无优惠券"
                :empty-no-margin="true"
                :load="loadData"
              >
                <template #default="{ data }">
                  <div
                    v-for="item in data"
                    :key="item.couponId"
                    :class="[_.item, !item.available && _.expired]"
                    @click="handleCouponChange(item)"
                  >
                    <div :class="_.left">
                      <template v-if="item.couponType === 2">
                        <div
                          :class="[
                            _.zhe,
                            !!(
                              item.ticketThirdName &&
                              item.ticketThirdName.trim()
                            ) && _.hasMax,
                          ]"
                        >
                          <div :class="_.value">
                            <span :class="_.amount">{{
                              item.denomination
                            }}</span>
                            <span :class="_.unit">折</span>
                          </div>
                          <div v-if="item.minPointAmt" :class="_.threshold">
                            {{ item.minPointAmt }}
                          </div>
                          <div
                            v-if="
                              item.ticketThirdName &&
                              item.ticketThirdName.trim()
                            "
                            :class="_.max"
                          >
                            {{ item.ticketThirdName.trim() }}
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div :class="_.amount">
                          <div :class="_.unit">¥</div>
                          <div :class="_.value">{{ item.discountedAmt }}</div>
                        </div>
                        <div :class="_.desc">{{ item.minPointAmt }}</div>
                      </template>
                    </div>
                    <div :class="_.right">
                      <div :class="_.main">
                        <div :class="_.content">
                          <div :class="_.name">{{ item.couponName }}</div>
                          <div :class="_.time">
                            <div :class="_.title">有效期：</div>
                            <div :class="_.value">{{ item.useTimeVal }}</div>
                          </div>
                        </div>
                        <van-radio
                          checked-color="#FF960A"
                          :name="item.couponId"
                          :class="_.radio"
                        />
                      </div>
                      <div v-if="item.couponType !== 2" :class="_.extra">
                        <div
                          :class="[
                            _.content,
                            !expandState[item.couponId] && _._ellipsis,
                          ]"
                        >
                          {{
                            [item.remarks, item.payType]
                              .filter(Boolean)
                              .join('；')
                          }}
                        </div>
                        <van-icon
                          :name="
                            expandState[item.couponId]
                              ? 'arrow-up'
                              : 'arrow-down'
                          "
                          :class="_.arrow"
                          @click.stop.prevent="handleExpandClick(item)"
                        />
                      </div>
                    </div>
                  </div>
                </template>
              </x-waterfall>
            </div>
          </van-radio-group>
          <div :class="_.actions">
            <div :class="_.action" @click="handleNoUseClick">不使用优惠券</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {
    apiMarketingCouponMyCouponNoUsableList,
    apiMarketingCouponMyCouponUsableList,
    apiMarketingCouponReceiveCode,
  } from '@/api'
  import { maxBy } from 'vtils'
  import { submit } from '@/utils'

  export default Vue.extend({
    props: {
      value: {
        type: Object,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      visible: false,
      code: '',
      typeIndex: 0,
      expandState: {},
      couponData: [],
      localRadio: undefined,
    }),

    computed: {
      localValue: {
        get() {
          return this.value
        },
        set(v) {
          this.$emit('input', v)
        },
      },
    },

    watch: {
      visible: {
        immediate: true,
        handler() {
          if (this.visible) {
            this.prepareData()
          }
        },
      },
      typeIndex: {
        immediate: true,
        handler() {
          if (this.visible) {
            this.$nextTick(() => {
              this.$refs.list?.reload()
            })
          }
        },
      },
    },

    created() {
      this.prepareData()
    },

    methods: {
      async prepareData() {
        this.code = ''
        this.typeIndex = 0
        this.expandState = {}
        const list = await apiMarketingCouponMyCouponUsableList(this.params, {
          noErrorToast: true,
        }).catch(() => [])
        this.couponData = list
        if (list.length) {
          if (
            !this.localValue?.couponId ||
            !list.find(item => item.couponId === this.localValue.couponId)
          ) {
            const localValue = maxBy(list, item => item.discountedAmt)
            const localRadio = localValue?.couponId
            this.localValue = localValue
            this.localRadio = localRadio
          }
        } else {
          this.localValue = {}
          this.localRadio = undefined
        }
        this.$nextTick(() => {
          this.$refs.list?.reload()
        })
      },
      loadData({ pageNumber }) {
        // return [{ discountedAmt: 1000 }, {}]
        return pageNumber > 1
          ? []
          : this.typeIndex === 0
          ? apiMarketingCouponMyCouponUsableList(this.params, {
              noErrorToast: true,
            })
              .catch(() => [])
              .then(res =>
                res.map(item => ({
                  ...item,
                  available: true,
                })),
              )
          : apiMarketingCouponMyCouponNoUsableList(
              {},
              {
                noErrorToast: true,
              },
            )
              .catch(() => [])
              .then(res =>
                res.map(item => ({
                  ...item,
                  available: false,
                })),
              )
      },
      handleClick() {
        this.visible = !this.visible
      },
      handleExchangeClick() {
        submit(async $ => {
          if (!this.code) {
            return $.fail('请输入优惠码')
          }
          await $.start('兑换中...')
          await apiMarketingCouponReceiveCode({
            couponCode: this.code,
          })
          $.success('兑换成功')
          this.$refs.list.reload()
        })
      },
      handleItemClick(item) {
        this.visible = !this.visible
        this.$emit('input', item.value)
      },
      handleExpandClick(item) {
        this.expandState = {
          ...this.expandState,
          [item.couponId]: !this.expandState[item.couponId],
        }
      },
      handleNoUseClick() {
        this.visible = false
        this.localValue = {}
        this.localRadio = undefined
        console.log(this.localRadio)
        this.$emit('input', {})
      },
      handleCouponChange(item) {
        this.localValue = item
        this.localRadio = item.couponId
        this.visible = false
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    .hd {
      padding: 12px 16px 0 12px;
      display: flex;
      align-items: center;

      .input {
        appearance: none;
        outline: none;
        border: none;
        border-radius: 0;
        box-shadow: none;

        width: 100%;
        flex-grow: 1;
        font-size: 14px;
        background: #f5f5f5;
        color: #222222;
        line-height: 20px;
        padding: 9px 12px;
        border-radius: 1000px;

        &::placeholder {
          color: #aaa;
        }
      }

      .button {
        margin-left: 16px;
        flex-shrink: 0;
        font-size: 16px;
        font-weight: bold;
        color: #ff960a;

        &:active {
          opacity: 0.8;
        }
      }
    }

    .bd {
      margin-top: 4px;

      .tabs {
        :global {
          .van-tab__text {
            font-size: 16px;
            color: #333333;
          }

          .van-tabs__line {
            background-color: #ff960a;
          }

          .van-tab--active {
            .van-tab__text {
              font-size: 16px;
              font-weight: bold;
              color: #ff960a;
            }
          }
        }
      }

      .list {
        padding: 12px;
        height: 50vh;
        overflow: auto;

        .item {
          display: flex;
          align-items: stretch;
          line-height: 1;
          border: 1px solid #ffe3d6;
          border-radius: 12px;
          overflow: hidden;

          &:not(:first-child) {
            margin-top: 12px;
          }

          .left {
            position: relative;
            width: 105px;
            flex-shrink: 0;
            background: #fff3ee;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-right: 2px dashed #ffe3d6;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .amount {
              display: flex;
              align-items: baseline;
              justify-content: center;
              padding-left: 6px;

              .unit {
                font-size: 12px;
                font-weight: bold;
                color: #fc5609;
              }

              .value {
                font-size: 26px;
                font-weight: bold;
                color: #fc5609;
                white-space: nowrap;
              }
            }

            .desc {
              margin-top: 4px;
              padding-left: 6px;
              font-size: 12px;
              color: #fc5609;
              text-align: center;
            }

            .zhe {
              .value {
                display: flex;
                align-items: baseline;
              }

              .amount {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 40px;
                color: #fc5609;
                line-height: 40px;
                font-style: normal;
              }

              .unit {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 12px;
                color: #fc5609;
                line-height: 17px;
                font-style: normal;
              }

              .threshold {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #fc5609;
                line-height: 17px;
                font-style: normal;
              }

              .max {
                position: absolute;
                left: 0;
                bottom: 0;
                right: 0;
                height: 26px;
                background: #ffe3d6;
                white-space: nowrap;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #fc5609;
                line-height: 26px;
                font-style: normal;
                border-bottom-left-radius: 12px;
                text-align: center;
              }

              &.hasMax {
                padding-bottom: 22px;
              }
            }
          }

          .right {
            flex-grow: 1;
            background-color: #fff9f7;
            overflow: hidden;

            .main {
              display: flex;
              align-items: center;
              padding: 12px;

              .content {
                flex-grow: 1;

                .name {
                  font-size: 14px;
                  font-weight: bold;
                  color: #333333;
                  line-height: 20px;
                }

                .time {
                  margin-top: 10px;
                  font-size: 12px;
                  color: #333333;
                  line-height: 17px;
                }
              }

              .radio {
                flex-shrink: 0;
              }
            }

            .extra {
              display: flex;
              align-items: center;
              padding: 4px 12px;
              border-top: 2px dashed #ffe3d6;

              .content {
                flex-grow: 1;
                font-size: 12px;
                color: #666666;
                line-height: 16px;
              }

              .arrow {
                margin-left: 6px;
                flex-shrink: 0;
                font-size: 14px;
                color: #ff960a;
              }
            }
          }

          &.expired {
            pointer-events: none;
            filter: grayscale(1) opacity(0.5);
          }
        }
      }

      .actions {
        padding: 10px 24px;

        .action {
          width: 100%;
          height: 44px;
          background: #ff960a;
          border-radius: 1000px;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;

          &:active {
            filter: contrast(0.9);
          }
        }
      }
    }
  }
</style>
